import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trending-1, trends"} maskId="square-filled-radius-0-stroke-1-IconTrending1"><path fillRule="evenodd" clipRule="evenodd" d="M13.1438 2.09302L18.4423 19.1597L21.2762 13.4548L22.1718 13.8996L18.2274 21.8402L12.9704 4.90696L7.84057 16.2668L4.59037 10.8141L2.64232 13.7554L1.80859 13.2033L4.63494 8.93585L7.71808 14.1082L13.1438 2.09302Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrending1;
